/**
 * The one place a push's `bb_variant` value is composed.
 *
 * Two sources name a test arm: the page-level ids the `?bbtest=` switch
 * resolves (the `data-bb-tests` attribute on `<main>`, registry ids such as
 * `a05a`) and the compact token a component reports for the arm it knows it
 * is rendering (`contact-first`, `drawer-office-card`, the `bbVariant`
 * argument of the push helpers in `lib/utils/dataLayerHelpers.ts`). A push
 * carries ONE flat `bb_variant` key, page ids first, then the component's
 * tokens that the ids do not already name, comma-separated and never
 * repeated, or no key at all when both are empty (the control payload).
 */
export function mergeBbVariant(...parts: ReadonlyArray<unknown>): string {
  const tokens: string[] = [];
  for (const part of parts) {
    if (typeof part !== "string") continue;
    for (const raw of part.split(",")) {
      const token = raw.trim();
      if (token !== "" && !tokens.includes(token)) tokens.push(token);
    }
  }
  return tokens.join(",");
}
